<template>
    <div class="member_center">
        <memberLeft></memberLeft>
        <div class="member_right">
            <memberBreadcrumb></memberBreadcrumb>
            <router-view />
        </div>
    </div>
</template>

<script>
    import memberLeft from './left.vue';
    import memberBreadcrumb from './breadcrumb.vue';
    export default {
        name: 'App',
        components: {
            memberLeft,
            memberBreadcrumb
        },
        data() {
            return {
                
            }
        }
    }
</script>

<style lang="scss">
    .member_center {
        width: 1100px;
        box-sizing: border-box;
        padding: 12px;
        box-shadow: 0 6px 20px #efdecc;
        border-radius: 10px;
        background: #FFF9F3;
        display: flex;
        justify-content: space-between;
        margin-top: 20px;
        .member_right {
            border: 1px solid #DDA76B;
            box-sizing: border-box;
            background: #ffffff;
            min-width: 800px;
            flex: 1;
            margin-left: 15px;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/member/main.vue